export default function getStylePropertyValue(propertyName: string) {
  return getComputedStyle(document.body).getPropertyValue(propertyName);
}

/**
 * Resolve a `var(…, fallback)` chain the way the stylesheet would: the first
 * variable that is actually set wins. Returns "" when none of them resolve.
 */
export function getFirstStylePropertyValue(propertyNames: string[]): string {
  const bodyStyle = getComputedStyle(document.body);

  return (
    propertyNames
      .map((propertyName) => bodyStyle.getPropertyValue(propertyName).trim())
      .find(Boolean) || ""
  );
}
